import {
  OMSMetricsRequestSchema,
  OMSMetricsResponseSchema,
} from "@redotech/redo-model/fulfillments/metrics";

export const getOnTimeDeliveryRate = {
  name: "getOnTimeDeliveryRate" as const,
  input: OMSMetricsRequestSchema,
  output: OMSMetricsResponseSchema,
};
